export const EVENTS_URL: string = import.meta.env.VITE_NEW_ADMITONE_URL;

export const NUVEI_MERCHANT_ID: number = import.meta.env.VITE_NUVEI_MERCHANT_ID;

export const NUVEI_SITE_ID: number = import.meta.env.VITE_NUVEI_SITE_ID;

export const NUVEI_ENV: string = import.meta.env.VITE_NUVEI_ENV;

export const RECAPTCHA_KEY: string = import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY;

export const APP_URL: string = import.meta.env.VITE_APP_URL;

export const COMMUNITY_URL: string =
    import.meta.env.VITE_NEW_ADMITONE_URL || 'https://newlanding-testing.vercel.app/';

export const A1_PRO_COLOR_PRIMARY = '#0368B6';

export const A1_COMMUNITY_COLOR_PRIMARY = '#4A7754';

export const A1_POWEREDBY_COLOR_PRIMARY = '#212B36';
